module.exports = __webpack_public_path__ + "img/7_98.3756fd8d.png";